/**
 * Paging limits for the client-facing search endpoint (/internal/records, and /internal/records/v2 until it is removed).
 * The API rejects anything beyond these, so they must match what the UIs can request.
 */
export const SearchPaging = {
  /** Largest rows-per-page option offered by the web search table. */
  MAX_PAGE_SIZE: 100,
  /** Deepest row a client may page to (from + size); matches the 10,000-row download/select cap. */
  MAX_RESULT_WINDOW: 10_000,
};
